"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBreadcrumbs = void 0;
var _fetching = require("@ori/fetching");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _utils = require("./utils");
/**
 * Fetch function that fetches breadcrumbs from static api.
 * @returns Parsed breadcrumbs in type `Breadcrumb[]`
 */
const getBreadcrumbs = async ({
  staticApiClient,
  language,
  pageId,
  tenant
}) => {
  const response = await (0, _staticApiClientReact.getTenantApplicationsBreadcrumbLinks)(staticApiClient, tenant, {
    lang: language,
    pageUrl: pageId
  }, {
    validateStatus:
    // istanbul ignore next @preserve --No need to test validateStatus.
    status => status >= _fetching.STATUS_OK
  });
  return response.status === _fetching.STATUS_OK ? (0, _utils.parseBreadcrumbsFromStaticApi)(response.data.links) : [];
};
exports.getBreadcrumbs = getBreadcrumbs;
